var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-location" }, [
    _c("div", { staticClass: "header-menu" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.location-title"))),
      ]),
    ]),
    _c("div", { staticClass: "search-bar" }, [
      _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.models.search,
            expression: "models.search",
          },
        ],
        attrs: { placeholder: _vm.$t("dash.post-creator.overlay.search") },
        domProps: { value: _vm.models.search },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.models, "search", $event.target.value)
          },
        },
      }),
    ]),
    _c(
      "div",
      { staticClass: "list-item hide-scrollbar" },
      [
        _vm.stateLoader
          ? _c("span", { staticClass: "loader" })
          : _vm._l(
              _vm.models.search
                ? _vm.locations
                : _vm.dataInstagramDefault.locations,
              function (place, index) {
                return _c(
                  "div",
                  {
                    key: `location${index}`,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.selectPlace(place)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "info" }, [
                      _c("p", { staticClass: "location" }, [
                        _vm._v(_vm._s(place.name)),
                      ]),
                      _c("p", { staticClass: "location-info" }, [
                        _vm._v(
                          _vm._s(
                            place.location.street ||
                              place.location.city ||
                              place.location.country ||
                              place.location.zip
                              ? `${place.location.street || ""} ${
                                  place.location.city || ""
                                } ${place.location.country || ""} ${
                                  place.location.zip || ""
                                }`
                              : place.name
                          )
                        ),
                      ]),
                    ]),
                  ]
                )
              }
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }